<template>
  <div>
    <Vue3Lottie
      :animation-link="animationLink"
      :loop="loop"
      :autoPlay="true"
      :speed="speed"
      :class="position"
      class="pointer-events-none top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
</template>

<script setup>
import {Vue3Lottie} from "vue3-lottie";
const props = defineProps({
  speed: {
    type: Number,
    default: 1
  },
  loop: {
    type: Boolean,
    default: false
  },
  isWhite: {
    type: Boolean,
    default: false
  },
  isFixed: {
    type: Boolean,
    default: true
  }
});

const animationLink = props.isWhite ?
  "https://resources.businessdraft.com/lottie/confetti-white.json" :
  "https://resources.businessdraft.com/lottie/confetti2.json";

const position = props.isFixed ? "fixed" : "absolute";
</script>
